import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import * as platformInstance from './platforminstance';

var getCurrentPlatform = function getCurrentPlatform() {
  var platform = Object.keys(platformInstance).filter(function (instance) {
    return platformInstance[instance].is();
  }).pop();
  return platform ? platformInstance[platform] : platformInstance.m;
};

export var platform = getCurrentPlatform();
export var isPlatformActive = function isPlatformActive(activePlatforms) {
  return ~[].concat(activePlatforms).indexOf(platform.name) || activePlatforms === 'all';
};